<div class="input-group align-items-center">
    <label for="searchBy" class="me-2">{{ 'brapi-sync.study-selector.search-by' | translate }}</label>
    <div class="col-4">
      <ng-select [items]="searchOptions" name="searchBySelect" bindLabel="name" bindValue="id" [(ngModel)]="searchSelected">
          <ng-template ng-label-tmp let-item="item">
              {{ item.name | translate }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-index="index">
              {{ item.name | translate }}
          </ng-template>
      </ng-select>
    </div>
    <button type="button" class="btn btn-info" (click)="openSearchModal()">
      <i class="fa fa-plus"></i>
    </button>
  </div>
